export const watch = {
  step(step) {
    this.checkStep({ step })
  },
  plaidAccountIds() {
    this.resetForm()
  }
}
